import {useState} from "react";

const meetingsData = [
    {id: 1, title: "AI & Machine Learning", date: "March 25, 2025"},
    {id: 2, title: "Web Development Trends", date: "April 10, 2025"},
    {id: 3, title: "Data Science & Analytics", date: "May 5, 2025"},
];

function MeetingsPage() {
    const [meetings] = useState(meetingsData);

    return (
        <div>
            <section className="heading-page header-text" id="top">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <h6>Here are our upcoming meetings</h6>
                            <h2>Upcoming Meetings</h2>
                        </div>
                    </div>
                </div>
            </section>

            <section className="meetings-page" id="meetings">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="meetings-list">
                                {meetings.map((meeting) => (
                                    <div key={meeting.id} className="meeting-item">
                                        <h4>{meeting.title}</h4>
                                        <p>{meeting.date}</p>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
}

export default MeetingsPage;
